import { render, staticRenderFns } from "./VueHero.vue?vue&type=template&id=d76c89ec&"
import script from "./VueHero.vue?vue&type=script&lang=js&"
export * from "./VueHero.vue?vue&type=script&lang=js&"
import style0 from "./VueHero.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VueHero.vue"
export default component.exports